// extracted by mini-css-extract-plugin
export default {"root":"IconSmallLogo_root__osHoQ","pencil":"IconSmallLogo_pencil__lNCHH"};